import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { PasswordResetComponent } from '../password-reset/password-reset.component';
import { SessionService } from '../services/session.service';
import { SnackbarService } from '../services/snackbar-service.service';
import { LoginService } from './login.service';
import { RecuperarPasswordComponent } from '../recuperar-password/recuperar-password.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  inSubmission = false;
  form: FormGroup;
  

  usuarioErrorsMsg = [
    { type: 'required', message: 'N° documento requerido.' },
    {
      type: 'minlength',
      message: 'Mínimo 6 caracteres',
    },
    {
      type: 'pattern',
      message: 'Solo se permiten números',
    },
  ]

  passwordErrorsMsg = [
    { type: 'required', message: 'Contraseña requerida.' },
    // {
    //   type: 'minlength',
    //   message: 'Mínimo 6 caracteres',
    // },
    // {
    //   type: 'pattern',
    //   message: 'Debe ingresar al menos una letra mayúscula, una minúscula y un número, no se permiten caracteres especiales',
    // },
  ]

  hideCurrent = true;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private snackbar: MatSnackBar,
    private loginService: LoginService,
    private sessionService: SessionService,
    private dialog: MatDialog,
    private snackbarSvc: SnackbarService,
  ) {
    this.initForm();
  }

  ngOnInit(): void {}

  initForm(): void {
    this.form = this.fb.group({
      username: new FormControl('', Validators.compose([
        Validators.minLength(6),
        Validators.required,
        Validators.pattern('[0-9]+$')
     ])),
      password: new FormControl('', Validators.compose([
        // Validators.minLength(6),
        Validators.required,
        // Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]+$')
     ])),
    });
  }

  login(): void {

    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.inSubmission = true;
    this.loginService.login(this.form.getRawValue()).subscribe((res: any) => {

      if (res.cambiarClave) {
        this.snackbar.dismiss();
        const dialog = this.dialog.open(PasswordResetComponent, {
          maxHeight: 600,
          maxWidth: 600,
          data: {
            token: res.token,
            mensaje: `Por motivos de seguridad por favor defina una nueva contraseña.`
          }
        });

        dialog.afterClosed().subscribe(() => {
          this.inSubmission = false;
        });
        return;

      }


      if (res.menuPermisos.length > 0) {
        this.sessionService.setSession(res);
        //si el usuario solo tiene acceso a 1 módulo
        if (res.menuPermisos.length == 1) {
          
          const menuPermiso = res.menuPermisos[0]
          const ruta = menuPermiso.url || (menuPermiso.modulo ? menuPermiso.modulo.toLowerCase() : '');

          this.sessionService.setModulo(menuPermiso.modulo.toLowerCase());

          //si el módulo no es interno, lo redirigimos a la url cargada en el campo 'url'
          if (!menuPermiso.interno) {
            const token = localStorage.getItem('session') 
              ? JSON.parse(localStorage.getItem('session')!).token 
              : null;

            if (token) {
              localStorage.clear();
              window.location.href = `${ruta}?token=${token}`;
            } else {
              this.router.navigate(['login']);
            }

          //si el módulo es interno, navegamos a través del proyecto base
          } else {

            const navigation = this.router.navigate([ruta]);
                        
            //en el caso de que la ruta local no exista, se le advirtirá al usuario, y el loading del módulo se reseteará
            //se limpiará el localStorage para que la sesión no pase como validada
            navigation.catch(() => {
              localStorage.clear()
              this.snackbarSvc.showMessage(`La ruta "${ruta}" no está disponible.`, 'warning');
              this.inSubmission = false;
            });
          }

        } else {
          this.router.navigate(['modulos']);
        }
        this.snackbarSvc.showMessage('BIENVENIDO', 'success');
      } else {
        this.inSubmission = false;
        this.snackbarSvc.showMessage('Su usuario no tiene módulos asignados. Verifique con el operador', 'warning');
      }
    },
    (error: any) => {
      this.inSubmission = false;
      console.error('Error al iniciar sesión:', error);
    }
    );

  }

  abrirModalRecuperacion(): void {
  const cedulaGuardada = this.form.get('username')?.value;

  this.dialog.open(RecuperarPasswordComponent, {
    width: '400px',
    data: {
      usuario: cedulaGuardada
    }
  });
}
}
